import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App'
import { restoreSession } from './utils/authSession'

const container = document.getElementById('root')
const root = createRoot(container)

// Primero se descifra el login guardado, para que la app arranque ya con la sesión.
restoreSession().finally(() => {
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
})
